import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import {
  SystemReportsState,
  SystemReportsStore
} from 'projects/app-misc/src/app/modules/reports/data/system-reports.store';

@Injectable({
  providedIn: 'root'
})
export class SystemReportsQuery extends QueryEntity<SystemReportsState> {
  searchQuery$ = this.select(state => state.ui.searchQuery);

  constructor(protected store: SystemReportsStore) {
    super(store);
  }
}
